import { defineArrayMember, defineField, defineType } from "sanity";

export const jewelryCarePage = defineType({
  name: "jewelryCarePage",
  title: "Jewelry Care Page",
  type: "document",
  groups: [
    { name: "content", title: "Content", default: true },
    { name: "cta", title: "Bottom CTA" },
    { name: "seo", title: "SEO" }
  ],
  fields: [
    defineField({
      name: "title",
      title: "Page Title",
      type: "string",
      description: "The main heading displayed at the top of the page.",
      group: "content"
    }),
    defineField({
      name: "intro",
      title: "Intro Text",
      type: "text",
      rows: 3,
      description: "The introductory paragraph shown below the title.",
      group: "content"
    }),
    defineField({
      name: "sectionLabel",
      title: "Section label",
      type: "string",
      description: "Small label above the page title (e.g. 'Jewelry Care').",
      group: "content"
    }),
    defineField({
      name: "sections",
      title: "Sections",
      type: "array",
      description: "The care tip sections displayed as numbered cards on the page. Drag to reorder.",
      of: [
        defineArrayMember({
          type: "object",
          fields: [
            defineField({
              name: "title",
              title: "Section Title",
              type: "string",
              validation: (Rule) => Rule.required()
            }),
            defineField({
              name: "body",
              title: "Section Body",
              type: "array",
              of: [{ type: "block" }]
            }),
            defineField({
              name: "image",
              title: "Section Image",
              type: "image",
              description: "Optional image to accompany this care tip.",
              options: { hotspot: true }
            })
          ],
          preview: {
            select: { title: "title" },
            prepare: ({ title }) => ({ title: title || "Untitled section" })
          }
        })
      ],
      group: "content"
    }),
    defineField({
      name: "bottomCtaHeading",
      title: "Bottom CTA heading",
      type: "string",
      description: "Heading for the bottom call-to-action section (e.g. 'Questions About Your Pieces?').",
      group: "cta"
    }),
    defineField({
      name: "bottomCtaBody",
      title: "Bottom CTA body",
      type: "text",
      rows: 3,
      description: "Body text for the bottom call-to-action section.",
      group: "cta"
    }),
    defineField({
      name: "bottomCtaButtonText",
      title: "Bottom CTA button text",
      type: "string",
      description: "Text for the bottom CTA button (e.g. 'Get in touch').",
      group: "cta"
    }),
    defineField({
      name: "bottomCtaButtonLink",
      title: "Bottom CTA button link",
      type: "string",
      description: "Link for the bottom CTA button (e.g. /contact).",
      group: "cta"
    }),
    defineField({
      name: "metaTitle",
      title: "Meta title",
      type: "string",
      description: "Page title for search engines (e.g. 'Caring for Your Pieces | Vault 88').",
      group: "seo"
    }),
    defineField({
      name: "metaDescription",
      title: "Meta description",
      type: "text",
      rows: 3,
      description: "Short description for search engines.",
      group: "seo"
    }),
    defineField({
      name: "ogImage",
      title: "Sharing image",
      type: "image",
      description: "Image shown when this page is shared on social media.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "seo"
    })
  ],
  preview: {
    prepare: () => ({ title: "Jewelry Care Page" })
  }
});
